import React, {useEffect} from 'react';
import PublicActionBar from "../../components/PublicActionBar";
import {BackTop, Layout, Space, Tag} from "antd";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import {Outlet, useLocation} from "react-router-dom";
import styled from 'styled-components';
import PublicFooter from "../../components/PublicFooter";
import {GREE_1} from "../../utils/colors";

const StyledLayout = styled(Layout)`
  min-height: 100vh;
`

const StyledBackTop = styled(BackTop)`
  .ant-back-top-icon {
    background: ${GREE_1};
  }
`

export default function PublicLayout() {
    const screens = useBreakpoint();
    const location = useLocation()

    useEffect(() => {
        window.scroll({top: 0})
    }, [location])
    return (
        <>
            {/*Current break point:{' '}*/}
            {/*{Object.entries(screens)*/}
            {/*    .filter((screen) => !!screen[1])*/}
            {/*    .map((screen) => (*/}
            {/*        <Tag color="blue" key={screen[0]}>*/}
            {/*            {screen[0]}*/}
            {/*        </Tag>*/}
            {/*    ))}*/}
            <StyledLayout>
                <PublicActionBar/>
                <Outlet/>
                <PublicFooter/>
                <StyledBackTop>

                </StyledBackTop>
            </StyledLayout>
        </>

    )
}